import React, { memo } from 'react';
import { Translate } from 'react-localize-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import css from './StepButtons.css';
import { Button } from '../../../../components/widgets';
import MemoChevronIcon from '../../MemoChevronIcon';

const StepButtons = ({
    onNext,
    onBack,
    nextTitle,
    backTitle,
    showNextIcon = true,
    isLast = false,
    isLoading = false,
}) => {
    return (
        <div className={css.buttonContainer}>
            {backTitle && (
                <Button
                    className={css.backButton}
                    textClassName={css.backText}
                    type="secondary"
                    level="level1"
                    onClick={onBack}
                >
                    <>
                        <MemoChevronIcon className={classNames(css.arrow, css.back)} />
                        <Translate id="STATIC.BUTTONS.BACK" />
                    </>
                </Button>
            )}
            {nextTitle && (
                <Button showSpinner={isLoading} submit={!!isLast} type="primary" onClick={onNext}>
                    <>
                        <Translate id={nextTitle} />
                        {showNextIcon && <MemoChevronIcon className={classNames(css.arrow, css.next)} />}
                    </>
                </Button>
            )}
        </div>
    );
};

StepButtons.propTypes = {
    nextTitle: PropTypes.string,
    backTitle: PropTypes.string,
    onBack: PropTypes.func,
    onNext: PropTypes.func,
    showNextIcon: PropTypes.bool,
    isLoading: PropTypes.bool,
    isLast: PropTypes.bool,
};

export default memo(StepButtons);
